import { render, staticRenderFns } from "./office-address.vue?vue&type=template&id=0bd5bcaf&scoped=true&"
import script from "./office-address.vue?vue&type=script&lang=js&"
export * from "./office-address.vue?vue&type=script&lang=js&"
import style0 from "./office-address.vue?vue&type=style&index=0&id=0bd5bcaf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd5bcaf",
  null
  
)

export default component.exports